import { render, staticRenderFns } from "./social-security-detail.vue?vue&type=template&id=33803c65&scoped=true"
import script from "./social-security-detail.vue?vue&type=script&lang=ts"
export * from "./social-security-detail.vue?vue&type=script&lang=ts"
import style0 from "./social-security-detail.vue?vue&type=style&index=0&id=33803c65&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33803c65",
  null
  
)

export default component.exports